import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Text from 'components/shared/Text';
import history from 'store/history';
import styles from './index.module.css';
import SignUpLayoutNew from 'layouts/SignUpLayoutNew';
import MobileContext from 'context/MobileContext';
import { useContext } from 'react';

const ThankYouPage = ({ message, header, linkTo, linkText }) => {
  const isMobile = useContext(MobileContext);
  useEffect(() => {}, []);

  const handleBackClick = () => {
    history.push('/login');
  };

  return (
    <SignUpLayoutNew
      width={isMobile ? '100%' : '550px'}
      height={isMobile ? '100%' : '450px'}
      isMobile={isMobile}
      headerName={'Forgot Password Email Sent'}
    >
      <div className={styles.page}>
        <Text tag="p" type="p4">
          {message}
        </Text>
        {linkTo && (
          <button type="button" className={styles.link} onClick={() => handleBackClick()}>
            {linkText}
          </button>
        )}
      </div>
    </SignUpLayoutNew>
  );
};

ThankYouPage.propTypes = {
  message: PropTypes.string,
  header: PropTypes.string,
  linkTo: PropTypes.string,
  linkText: PropTypes.string,
};

ThankYouPage.defaultProps = {
  message: '',
  linkTo: '',
  linkText: '',
  header: 'Thank you!',
};

export default ThankYouPage;
